import React from 'react';
import { Link } from 'react-router-dom';
import { MenuItems } from './MenuItems';
// import { Button } from './Button';
import '../CSS/Dropdown.css';
import "@fontsource/federo";

class Dropdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isClick: false, 
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleLinkClick = this.handleLinkClick.bind(this);

    }

    handleClick () {
        this.setState({isClick: !this.state.isClick});
    }

    handleLinkClick () {
        this.setState({isClick: false}); 
    }

    render () { 
        // if (this.props.sidebar === true) {
        //     console.log("sidebar:", this.props.sidebar);
        // }
        return (
            <div
            onClick={this.handleClick}
            className={this.state.isClick 
                ? 'dropdown-menu clicked '  + (this.props.sidebar ? 'sidebar ' : '')
                : 'dropdown-menu '          + (this.props.sidebar ? 'sidebar ' : '' ) }>
                {MenuItems.map((item, index) => {
                    if (item.type === this.props.id) {
                        return (
                            <div key={index}>
                                <Link 
                                className={item.cName} 
                                to={item.path} 
                                onClick={this.handleLinkClick}
                                >{item.title}</Link>
                            </div>
                        )
                    }
                    return null

                })}
            </div>
        );
    }
}

export default Dropdown;
